/** A touch-first screen: focusing a text field there raises the on-screen
 * keyboard over half of it, so a panel or menu with a field opens with the
 * field unfocused (user, Oct 2026: on a phone the keyboard hid Save for
 * everyone in Tune details). */
export function touchFirst(): boolean {
  return window.matchMedia?.('(pointer: coarse)').matches ?? false;
}
